<router-outlet />
<p-confirmDialog />
<ui-toast />
<ui-preview />
